import { Injectable, OnDestroy } from '@angular/core';
import { select } from '@angular-redux/store';
import { AuthObj, User } from '@core/redux/stores';

import { LocTrackingService } from '@core/services/location-tracking.service';

import { Observable ,  Subscription } from 'rxjs';
import { LoggingService } from '@core/services/logging.service';
import { GeofenceService } from '@core/services/geofence.service';

@Injectable()
export class LoggedDataService {
    isLoggedIn: Boolean = false;
    authToken: string;
    refreshToken: string;
    firstName: string;
    lastName: string;
    email: string;
    giftCardNumber: string;
    isSocial: Boolean = false;
    isEmailVerified: Boolean;
}

@Injectable()
export class AuthTrackingService implements OnDestroy {
    @select((appState) => appState.auth) auth: Observable<AuthObj>;
    @select((appState) => appState.user) user: Observable<User>;

    private subscriptions = new Subscription();
    private signedInUserEmail: string;
    public DELETE_ACCOUNT_ROUTE = 'initiate-delete-account';
  constructor(
    private loggedDataService: LoggedDataService,
    private locTrackingService: LocTrackingService,
    private logger: LoggingService,
    private geofence: GeofenceService
  ) {
    this.loggedDataService.isLoggedIn = false;
    this.loggedDataService.isSocial = false;

      this.subscriptions.add(
        this.auth.subscribe(
          (resp) => {
            this.updateAuthResp(resp);
          }
        )
      );

      this.subscriptions.add(
        this.user.subscribe(
          (resp) => {
            this.updateUser(resp);
          }
        )
      );
    }

    ngOnDestroy() {
      this.subscriptions.unsubscribe();
    }

  updateUser(resp: User) {
    if (resp !== undefined && resp !== null) {
      if (resp.id) {
        this.geofence.setUserId(resp.id);
        this.logger.setAuthenticatedUserContext(
          resp.id,
          resp.mainAccountType,
          true
        );
      } else {
        this.logger.clearAuthenticatedUserContext();
      }
      this.loggedDataService.firstName = resp.firstName;
      this.loggedDataService.lastName = resp.lastName;
      this.loggedDataService.email = resp.email;
      this.loggedDataService.giftCardNumber = resp.giftCardNumber;
      this.locTrackingService.updateZipCode(resp.zipCode as string);
      this.loggedDataService.isEmailVerified = resp.isEmailVerified;
      if (resp.mainAccountType === 'Local') {
        this.loggedDataService.isSocial = false;
      } else {
        this.loggedDataService.isSocial = true;
      }
    } else {
      this.loggedDataService.firstName = '';
      this.loggedDataService.lastName = '';
      this.loggedDataService.email = '';
      this.loggedDataService.giftCardNumber = '';
      this.locTrackingService.updateZipCode('');
      this.loggedDataService.isSocial = false;
    }
  }

    updateAuthResp(authRes: AuthObj) {
      if (authRes !== null && authRes.tokenInfo !== undefined) {
        if (authRes.tokenInfo.accessToken !== undefined && authRes.tokenInfo.accessToken !== null) {
          this.loggedDataService.isLoggedIn = true;
          this.loggedDataService.authToken = authRes.tokenInfo.accessToken;
          const rt = authRes.tokenInfo.refreshToken;
          this.loggedDataService.refreshToken =
            rt != null && rt !== ''
              ? rt
              : (this.loggedDataService.refreshToken || '');
        } else {
          this.loggedDataService.isLoggedIn = false;
          this.loggedDataService.authToken = '';
          this.loggedDataService.refreshToken = '';
        }
      } else {
        // for some reason something is wrong with the redux auth token. clear cache and treat it as if the user is signed-out
        this.loggedDataService.isLoggedIn = false;
        this.loggedDataService.authToken = '';
        this.loggedDataService.refreshToken = '';
      }
    }

    updateAuth(value: boolean, token: string = '') {
        this.loggedDataService.isLoggedIn = value;
        this.loggedDataService.authToken = token;
    }

    isLoggedIn() {
        return this.loggedDataService.isLoggedIn;
    }

    getAuthToken() {
      return this.loggedDataService.authToken;
    }

    getRefreshToken() {
      return this.loggedDataService.refreshToken;
    }

    getFirstName() {
      return this.loggedDataService.firstName;
    }

    getLastName() {
      return this.loggedDataService.lastName;
    }

    getUserEmail() {
      return this.loggedDataService.email;
    }

    getUserRewardNum() {
      return this.loggedDataService.giftCardNumber;
    }

    isSocial() {
      return this.loggedDataService.isSocial;
    }

    isVerified() {
      return this.loggedDataService.isEmailVerified;
    }
    setSignedOutUserEmail() {
      this.signedInUserEmail = this.loggedDataService.email;
    }
    getSignedOutUserEmail() {
      return this.signedInUserEmail;
    }
    clearSignedOutUserEmail() {
      this.signedInUserEmail = '';
    }
  }
